 
 
 <mat-card *ngIf="selectedClient && selectedClient.prospectId" style="width: 800px;margin: auto;margin-top: 100px;" [class.mat-elevation-z8]='true'  >
   <mat-card-header>
     <mat-card-title style="color: red;text-transform: capitalize;"> {{selectedClient.prospectId.raisonSocial}}</mat-card-title>
     <mat-card-subtitle>Veuillez Selectioner le projet et le type du client</mat-card-subtitle>
   </mat-card-header>
   <mat-card-content>
     
      <mat-form-field *ngIf="projectList">
          <mat-label>Séléctioner un Projet (Salon) </mat-label>
          <mat-select    [(value)]="selectedProject"  [compareWith]="compareFnProject"  >
            <mat-option *ngFor="let selectedProject of projectList" [value]="selectedProject">
              {{selectedProject.numeroFiche}}
            </mat-option>
          </mat-select>
        </mat-form-field>


      
        <mat-form-field *ngIf="selectedUser" >
          <mat-label>Concrétisé par </mat-label>
          <mat-select    [(value)]="selectedUser"  [compareWith]="compareFn" >
            <mat-option *ngFor="let user of usersList" [value]="user">
              {{user.nom}}
            </mat-option>
          </mat-select>
        </mat-form-field>

   </mat-card-content>
   <mat-card-actions>
     <button mat-raised-button color='primary' (click)="createFichE('E')">Créer Fiche Exposant</button>   
     <button mat-raised-button color='accent'  (click)="createFichE('D')" >Créer Fiche Délégué</button> 
     <button mat-raised-button color='warn' (click)="createFichE('S')" >Créer Fiche Sponsor</button> 
     <button mat-raised-button color='primary' (click)="createFichE('ES')" >Créer Fiche Exposant Sponsor</button> 
       <button mat-raised-button color='danger' (click)="CoExhibitor()">Créer Fiche CO-Exposant</button>
   </mat-card-actions>
 </mat-card>



 
 